module.exports = __webpack_public_path__ + "static/img/img_7.64149e53.jpg";